/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Edit2, Trash } from "react-feather";

import Table, { TableHeading } from "../../../shared/Table/Table";
import DeleteModal from "../../../shared/Modals/DeleteModal/DeleteModal";
import Empty from "../../../shared/Empty/Empty";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import {
  deleteSuccessStory,
  getSuccessStories,
  reorderSuccessStories,
  toggleSuccessStoryStatus,
} from "../../../store/features/AdminPanel/SuccessStories/successStoriesApi";
import {
  editStory,
  reorderStoriesLocal,
} from "../../../store/features/AdminPanel/SuccessStories/successStoriesSlice";
import "./successStories.scss";

const SuccessStoriesTable = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pendingId, setPendingId] = useState<number | string>("");
  const dispatch = useAppDispatch();
  const state: any = useAppSelector((s: RootState) => s.SuccessStoriesSlice);

  useEffect(() => {
    dispatch(getSuccessStories());
  }, [dispatch]);

  useEffect(() => {
    if (state.req_success.delete) setShowDeleteModal(false);
  }, [state.req_success.delete]);

  const onDelete = () => dispatch(deleteSuccessStory(pendingId));
  const onEdit = (story: any) => dispatch(editStory(story));
  const onToggle = (id: number | string) =>
    dispatch(toggleSuccessStoryStatus(id));

  const onDragEnd = (result: any) => {
    const { destination, source } = result;
    if (!destination) return;
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    dispatch(
      reorderStoriesLocal({
        sourceIndex: source.index,
        destinationIndex: destination.index,
      })
    );

    const next = [...state.stories];
    const moved = next.splice(source.index, 1)[0];
    next.splice(destination.index, 0, moved);

    const orders = next.map((s: any, idx: number) => ({
      id: s.id,
      order: idx + 1,
    }));

    dispatch(reorderSuccessStories({ orders }));
  };

  return (
    <div className="success-stories-table">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="success-stories-droppable">
          {(provided) => (
            <Table
              heading={
                <TableHeading>
                  <th className="ss-col-name">Name</th>
                  <th className="ss-col-role">Role</th>
                  <th className="ss-col-quote">Quote</th>
                  <th className="ss-col-pages">Pages</th>
                  <th className="ss-col-video">Video</th>
                  <th className="ss-col-status">Status</th>
                  <th className="hide__text ss-col-actions">.</th>
                </TableHeading>
              }
            >
              <tbody ref={provided.innerRef}>
                {!state.loading.get &&
                  state.req_success.get &&
                  state.stories.map((story: any, index: number) => (
                    <Draggable
                      draggableId={story.id.toString()}
                      key={story.id.toString()}
                      index={index}
                    >
                      {(p) => (
                        <tr
                          className="table_row_text"
                          {...p.draggableProps}
                          {...p.dragHandleProps}
                          ref={p.innerRef}
                        >
                          <td className="ss-col-name">
                            <div className="ss-name-cell">
                              {story.avatar ? (
                                <img
                                  className="ss-row-avatar"
                                  src={story.avatar}
                                  alt={story.name}
                                />
                              ) : (
                                <span className="ss-row-avatar ss-row-avatar--placeholder">
                                  {story.initials || "?"}
                                </span>
                              )}
                              <span className="ss-name-text ss-clamp-2">
                                {story.name}
                              </span>
                            </div>
                          </td>
                          <td className="ss-col-role">
                            <span className="ss-clamp-2">
                              {story.role || story.tags || "-"}
                            </span>
                          </td>
                          <td className="ss-col-quote">
                            <span className="ss-clamp-2">
                              {story.quote || "-"}
                            </span>
                          </td>
                          <td className="ss-col-pages">
                            <div className="ss-page-badges">
                              {story.show_on_success_stories && (
                                <span className="ss-badge ss-badge--ss">
                                  SS
                                </span>
                              )}
                              {story.show_on_program_testimonials && (
                                <span className="ss-badge ss-badge--pt">
                                  PT
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="ss-col-video">
                            {story.youtube_url ? (
                              <a
                                href={story.youtube_url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Open
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="ss-col-status">
                            <label
                              className="ss-toggle"
                              htmlFor={`ss-status-${story.id}`}
                            >
                              <span className="visually-hidden">
                                Toggle status
                              </span>
                              <input
                                id={`ss-status-${story.id}`}
                                type="checkbox"
                                aria-label="Toggle status"
                                checked={!!story.status}
                                onChange={() => onToggle(story.id)}
                                disabled={state.loading.toggle}
                              />
                              <span className="ss-toggle-slider" />
                            </label>
                          </td>
                          <td className="drag__team__action__icons ss-col-actions">
                            <div className="action__section__action">
                              <div className="drag_test_4544">
                                <Edit2
                                  className="edit__icon"
                                  onClick={() => onEdit(story)}
                                />
                                <Trash
                                  className="delete__icon"
                                  onClick={() => {
                                    setPendingId(story.id);
                                    setShowDeleteModal(true);
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </tbody>
            </Table>
          )}
        </Droppable>
      </DragDropContext>

      {!state.loading.get &&
        state.req_success.get &&
        state.stories.length === 0 && (
          <div className="mt-5 handle__empty__container__div">
            <Empty
              emptyText="It seems empty."
              emptyColorFulText="Add story"
              emptyText2="now."
              custombg={true}
            />
          </div>
        )}

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        loading={state.loading.delete}
        onClick={onDelete}
      />
    </div>
  );
};

export default SuccessStoriesTable;
